import React, { useMemo } from "react";
import { Editor } from "@tinymce/tinymce-react";

// Import TinyMCE core + plugins + skins (self-hosted)
import "tinymce/tinymce";
import "tinymce/icons/default";
import "tinymce/themes/silver";
import "tinymce/models/dom";
import "tinymce/plugins/advlist";
import "tinymce/plugins/autolink";
import "tinymce/plugins/lists";
import "tinymce/plugins/link";
import "tinymce/plugins/image";
import "tinymce/plugins/media";
import "tinymce/plugins/charmap";
import "tinymce/plugins/preview";
import "tinymce/plugins/anchor";
import "tinymce/plugins/searchreplace";
import "tinymce/plugins/visualblocks";
import "tinymce/plugins/code";
import "tinymce/plugins/table";
import "tinymce/plugins/wordcount";
import "tinymce/plugins/autoresize";
import "tinymce/plugins/directionality";
import "tinymce/plugins/fullscreen";

// Skins
import "tinymce/skins/ui/oxide/skin.min.css";
import "tinymce/skins/ui/oxide/content.min.css";
import "tinymce/skins/content/default/content.css";

const FONT_FAMILIES = [
  { label: "Default", value: "Helvetica Neue, Helvetica, Arial, sans-serif" },
  { label: "Traditional Arabic", value: "Traditional Arabic, serif" },
  { label: "Times New Roman", value: "Times New Roman, Times, serif" },
  { label: "Tahoma", value: "Tahoma, Geneva, sans-serif" },
  { label: "Courier New", value: "Courier New, monospace" },
];

const FONT_SIZES = ["10px", "12px", "14px", "16px", "18px", "24px", "32px"];

const TinyEditor = ({ value, onChange, minHeight = 300 }) => {
  const fontFormats = useMemo(
    () => FONT_FAMILIES.map((f) => `${f.label}=${f.value}`).join("; "),
    []
  );

  const editorConfig = {
    height: minHeight,
    menubar: false,
    branding: false,
    promotion: false,
    license_key: "gpl",
    toolbar_mode: "sliding",
    skin: false,
    content_css: false,
    paste_as_text: true,
    plugins: [
      "advlist",
      "autolink",
      "lists",
      "link",
      "image",
      "media",
      "charmap",
      "preview",
      "anchor",
      "searchreplace",
      "visualblocks",
      "code",
      "table",
      "wordcount",
      "autoresize",
      "directionality",
      "fullscreen",
    ],
    toolbar:
      "undo redo | blocks fontfamily fontsize | bold italic underline strikethrough forecolor backcolor |" +
      "alignleft aligncenter alignright alignjustify | ltr rtl | bullist numlist outdent indent |" +
      "link image media | table | removeformat | code preview fullscreen",
  };

  return (
    <Editor
      value={value || ""}
      init={editorConfig}
      onEditorChange={(content) => onChange && onChange(content)}
    />
  );
};

export default TinyEditor;
